export const SET_CONVERSATIONS = 'MESSENGER/SET_CONVERSATIONS'
export const APPEND_CONVERSATIONS = 'MESSENGER/APPEND_CONVERSATIONS'
export const SET_CONVERSATION = 'MESSENGER/SET_CONVERSATION'
export const SET_MESSAGES = 'MESSENGER/SET_MESSAGES'
export const ADD_MESSAGE = 'MESSENGER/ADD_MESSAGE'
export const PREPEND_MESSAGES = 'MESSENGER/PREPEND_MESSAGES'
export const UPDATE_MESSAGE_STATUS = 'MESSENGER/UPDATE_MESSAGE_STATUS'
export const SET_TEMPLATES = 'MESSENGER/SET_TEMPLATES'
export const UPDATE_CONVERSATION = 'MESSENGER/UPDATE_CONVERSATION'
export const REMOVE_CONVERSATION = 'MESSENGER/REMOVE_CONVERSATION'
export const SET_LOADING = 'MESSENGER/SET_LOADING'
